<nav class="dropdown">
  <button
    type="button"
    class="dropdown__button"
    aria-label="Mehr Optionen"
    [attr.aria-expanded]="isOpen"
    (click)="toggleDesktopMenu(!isOpen)">
    <img src="assets/brand/menu-lines.svg" alt="" class="size-6" />
  </button>
  @if (isOpen) {
    <ul
      class="menu menu--sub"
      [ngClass]="{ open: isOpen }"
      [appOutSideClick]="isOpen"
      (outSideClick)="isOpen = false">
      <li class="menu__item">
        <a
          class="menu__item__link"
          [href]="url + 'fur-fachkrafte'"
          (click)="handleClick()">
          Für Fachkräfte
        </a>
      </li>
      <li class="menu__item">
        <a
          class="menu__item__link"
          [href]="url + 'team'"
          (click)="handleClick()">
          Über uns
        </a>
      </li>
      <li class="menu__item">
        <a
          class="menu__item__link"
          [href]="url + 'kontakt'"
          (click)="handleClick()">
          Kontakt &amp; Support
        </a>
      </li>
    </ul>
  }
</nav>
